import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Box, Text } from 'core/ui/atoms';

const PaymentDetails = ({ deliveryDays, userSwapsForDeliveryDay }) => {
  const renderOrderDays = userSwapsForDeliveryDay
    .map(({ dayId }) => deliveryDays.find((day) => day.id === dayId))
    .filter(Boolean);

  const renderOrderDetails = () => {
    return renderOrderDays.map((item, index) => (
      <OrderDetailText key={index}>
        {`Order details: Meal for Week of ${moment(item.date).format('MMMM Do')}
         Payment cycle : ${moment(item.cutoffTime).subtract(2, 'days').format('MMMM Do')} 6AM.`}
      </OrderDetailText>
    ));
  };

  return (
    <Box>
      {renderOrderDetails()}
    </Box>
  );
};

PaymentDetails.propTypes = {
  deliveryDays: PropTypes.array.isRequired,
  userSwapsForDeliveryDay: PropTypes.array.isRequired,
};

const OrderDetailText = styled(Text)`
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  padding-right: 25px;
  padding-left: 25px;
  padding-bottom: 20px;
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyPoppins};
`;

export default PaymentDetails;
